<script>
import Locale from "@/utils/Locale";
import Translations from "@/Translations";

export default {
    data() {
        return {
            translations: Translations
        };
    },
    methods: {
        getPublicImage(filename) {
            return process.env.BASE_URL + "img/" + filename;
        },
        getPublicVideo(filename) {
            return process.env.BASE_URL + "videos/" + filename;
        },
        getInitials(str) {
            str = str.trim();

            if(!str.length)
                return "..";

            let strArray = str.split(" ");
            if(strArray.length === 1)
                return strArray[0][0].toUpperCase();
            
            return `${strArray[0][0].toUpperCase()}${strArray[strArray.length - 1][0].toUpperCase()}`;
        },
        __(key, source) {
            return Locale._translate(key, source, this.$store.getters.appLanguage);
        },
        pinSort(firstElement, secondElement) {
            /**
             * Check the compareFunction of Array.sort().
             * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort#Description
             */
            if(firstElement.IsPinned === 1 && secondElement.IsPinned === 0)
                return -1;
            if(firstElement.IsPinned === 0 && secondElement.IsPinned === 1)
                return 1;
            return 0;
        },
        moveElementInArray(arr, oldIndex, newIndex) {
            while (oldIndex < 0)
                oldIndex += arr.length;

            while (newIndex < 0)
                newIndex += arr.length;

            if (newIndex >= arr.length) {
                var k = newIndex - arr.length;
                while ((k--) + 1)
                    arr.push(undefined);
            }

            arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);  
            return arr;
        },
        lightenHex(color, percent) {
            let number = parseInt(color.replace("#", ""), 16);
            let amount = Math.round(2.55 * percent);
            let R = (number >> 16) + amount;
            let G = (number & 0x0000FF) + amount;
            let B = (number >> 8 & 0x00FF) + amount;

            return (0x1000000 + (R<255?R<1?0:R:255)*0x10000 + (B<255?B<1?0:B:255)*0x100 + (G<255?G<1?0:G:255))
                .toString(16)
                .slice(1);
        }
    }
}
</script>
